import { render, staticRenderFns } from "./AppWizardProgress.vue?vue&type=template&id=21067688&scoped=true"
import script from "./AppWizardProgress.vue?vue&type=script&lang=ts"
export * from "./AppWizardProgress.vue?vue&type=script&lang=ts"
import style0 from "./AppWizardProgress.vue?vue&type=style&index=0&id=21067688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21067688",
  null
  
)

export default component.exports